import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

// X-axis labels
const labels = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

// Dataset 2: Profit + Forecast
const profitData = [
  10, 17.5, 22.5, 28.75, 34.5, 42.5, 47.8, 52.845, 57.8, 63.265, 87.5, 105,
];
const CashtData = [
  12.5, 21.875, 28.125, 35.9375, 43.125, 53.125, 59.75, 66.05625, 72.25,
  79.08125, 109.375, 131.25,
];
const forecastData = [
  2.5, 4.375, 5.625, 7.1875, 8.625, 10.625, 11.95, 13.21125, 14.45, 15.81625,
  21.875, 26.25,
];

// Chart options generator
const generateOptions = (title, min, max) => ({
  responsive: true,
  scales: {
    y: {
      min: min - 0,
      max: max + 40,
      title: {
        display: true,
         text: " TopCoin UK Cash Value",
      },
      ticks: {
        callback: (value) => "£" + value.toLocaleString(),
      },
    },

      x:{
        title: {
        display: true,
        text: "Time Period",
      },
    }
 
  },
  plugins: {
    legend: { position: "bottom" },
    title: { display: false, text: title },
  },
});

// Chart data generator
const generateChartData = (datasets) => ({
  labels,
  datasets,
});

const ChartPoint = () => {
  const chart2Min = Math.min(...profitData, ...forecastData);
  const chart2Max = Math.max(...profitData, ...forecastData);

  return (
    <>
      <div className="text-center py-4">
        <h4 className="text-theme">
         Graph illustrating the accumulation of TopCoin UK Units Current Cash Value
        </h4>
      </div>
      <div
        className="chart-wrapper"
        style={{ backgroundColor: "#F8DB04", padding: "20px" }}
      >
        {/* Chart 2: Profit & Forecast */}

        <Line
          data={generateChartData([
            {
              label: "TopCoin UK Units Value",
              data: profitData,
              borderColor: "rgba(0,0,103,1)",
              backgroundColor: "rgba(54,162,235,0.2)",
              tension: 0.4,
            },
            // {
            //   label: "TopCoin UK Net Value",
            //   data: CashtData,
            //   borderColor: "rgba(136,162,20,1)",
            //   backgroundColor: "rgba(54,162,235,0.2)",
            //   tension: 0.4,
            // },
            // {
            //    label: "TopCoin UK Cash Value",
              
            //   data: forecastData,
            //   borderColor: "rgba(227,111,47,1)",
            //   backgroundColor: "rgba(255,206,86,0.2)",
            //   tension: 0.4,
            // },
          ])}
          options={generateOptions("Time Period", chart2Min, chart2Max)}
        />
      </div>
    </>
  );
};

export default ChartPoint;
